(function () {
  "use strict";

  window.UA_CATALOG = window.UA_CATALOG || {};

  function readUrlState(state) {
    var params = new URLSearchParams(window.location.search);
    state.page = Math.max(1, Number(params.get("catalogPage") || 1));
    state.filters.categoryId = params.get("categoryId") || "ALL";
    state.filters.brand = params.get("brand") || "";
    state.filters.color = params.get("color") || "";
    state.filters.size = params.get("size") || "";
    state.filters.search = params.get("search") || "";
    state.filters.tag = params.get("tag") || params.get("package") || "";
  }

  function syncUrl(state) {
    var url = new URL(window.location.href);
    var params = url.searchParams;

    if (state.page > 1) params.set("catalogPage", String(state.page));
    else params.delete("catalogPage");

    if (state.filters.categoryId && state.filters.categoryId !== "ALL") {
      params.set("categoryId", state.filters.categoryId);
    } else {
      params.delete("categoryId");
    }

    ["brand", "color", "size", "search", "tag"].forEach(function (key) {
      var value = state.filters[key];
      if (value) params.set(key, value);
      else params.delete(key);
    });

    window.history.replaceState({}, "", url.toString());
  }

  async function load(state, options) {
    options = options || {};

    state.requestSequence = Number(state.requestSequence || 0) + 1;
    var requestSequence = state.requestSequence;
    state.loading = true;

    if (!options.keepCards) {
      window.UA_CATALOG.render.skeletons(state);
    } else {
      window.UA_CATALOG.render.loadingState(state, true);
    }

    try {
      var payload = await window.UA_CATALOG.api.loadPage(state);

      if (requestSequence !== state.requestSequence) {
        return;
      }

      window.UA_CATALOG.render.response(state, payload);
      syncCompareButtons(state);
      renderCompareTray(state);
      updateDynamicTitle(state);
      syncUrl(state);
      window.UA_CATALOG.api.preloadNext(state);
    } catch (error) {
      if (error && error.name === "AbortError") return;
      window.UA_CATALOG.render.error(
        state,
        "Unable to load products. Please refresh the page and try again."
      );
      console.error("[UA Catalog]", error);
    } finally {
      if (requestSequence === state.requestSequence) {
        state.loading = false;
        window.UA_CATALOG.render.loadingState(state, false);
      }
    }
  }

  function setSidebarOpen(state, open) {
    var root = state.root;
    var sidebar = root.querySelector("[data-ua-catalog-sidebar]");
    var sidebarClose = root.querySelector("[data-ua-catalog-sidebar-close]");
    var sidebarBackdrop = root.querySelector("[data-ua-catalog-sidebar-backdrop]");
    var toggle = root.querySelector("[data-ua-catalog-filter-toggle]");
    var backdrop = root.querySelector("[data-ua-catalog-sidebar-backdrop]");

    sidebar.classList.toggle("is-open", open);
    toggle.setAttribute("aria-expanded", open ? "true" : "false");

    if (backdrop) {
      backdrop.hidden = !open;
      backdrop.classList.toggle("is-open", open);
    }

    document.documentElement.classList.toggle(
      "ua-catalog-drawer-open",
      open && window.matchMedia("(max-width: 749px)").matches
    );
  }

  function openSelectedCategoryBranch(state) {
    var activeId = String(state.filters.categoryId || "ALL");

    function walk(nodes) {
      for (var i = 0; i < nodes.length; i += 1) {
        var node = nodes[i];
        var children = Array.isArray(node.children) ? node.children : [];

        if (String(node.id) === activeId) {
          return true;
        }

        if (walk(children)) {
          state.expandedCategoryIds[String(node.id)] = true;
          return true;
        }
      }

      return false;
    }

    walk(state.categories || []);
  }

  function updateCategoryScrollButtons(state) {
    var root = state.root;
    var scroller = root.querySelector("[data-ua-catalog-categories-scroll]");
    var up = root.querySelector("[data-ua-catalog-categories-up]");
    var down = root.querySelector("[data-ua-catalog-categories-down]");

    if (!scroller || !up || !down) return;

    var maxScrollTop = Math.max(
      0,
      Math.ceil(scroller.scrollHeight - scroller.clientHeight)
    );
    var current = Math.max(0, Math.round(scroller.scrollTop));
    var canScroll = maxScrollTop > 3;

    up.disabled = !canScroll || current <= 2;
    down.disabled = !canScroll || current >= maxScrollTop - 2;
  }

  function queueCategoryScrollButtonUpdate(state) {
    window.requestAnimationFrame(function () {
      updateCategoryScrollButtons(state);

      window.requestAnimationFrame(function () {
        updateCategoryScrollButtons(state);
      });
    });

    window.setTimeout(function () {
      updateCategoryScrollButtons(state);
    }, 120);

    window.setTimeout(function () {
      updateCategoryScrollButtons(state);
    }, 350);
  }

  function resetCategoryScroll(state) {
    var scroller = state.root.querySelector(
      "[data-ua-catalog-categories-scroll]"
    );

    if (!scroller) return;

    scroller.scrollTop = 0;
    queueCategoryScrollButtonUpdate(state);
  }

  function scrollCategories(state, direction) {
    var scroller = state.root.querySelector(
      "[data-ua-catalog-categories-scroll]"
    );

    if (!scroller) return;

    var distance = Math.max(
      120,
      Math.floor(scroller.clientHeight * 0.72)
    );

    scroller.scrollBy({
      top: direction * distance,
      behavior: "smooth"
    });
  }

  function findCategoryName(nodes, categoryId) {
    var target = String(categoryId || "");

    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];

      if (String(node.id) === target) {
        return node.name || "";
      }

      var childName = findCategoryName(
        Array.isArray(node.children) ? node.children : [],
        target
      );

      if (childName) return childName;
    }

    return "";
  }

  function selectedOptionText(select) {
    if (!select || !select.value) return "";

    var option = select.options[select.selectedIndex];
    return option ? String(option.textContent || "").trim() : "";
  }

  function normalizedFilterTag(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[\s-]+/g, "_");
  }

  function isPackageDealsTag(value) {
    var tag = normalizedFilterTag(value);

    return (
      tag === "curated_package_deals" ||
      tag === "package_deals" ||
      tag === "package_deal"
    );
  }

  function updateDynamicTitle(state) {
    var root = state.root;
    var title = root.querySelector(".ua-catalog__title");

    if (!title) return;

    var parts = [];
    var activePackage = root.querySelector(
      "[data-package-tag].is-active"
    );

    if (activePackage) {
      parts.push(
        String(activePackage.textContent || "").trim()
      );
    } else if (isPackageDealsTag(state.filters.tag)) {
      // The featured Package Deals link is an <a> without data-package-tag,
      // so derive the label from state when the page was opened by URL.
      parts.push("Package Deals");
    } else if (state.smartSearchLabel) {
      parts.push(String(state.smartSearchLabel).trim());
    }

    if (
      state.filters.categoryId &&
      state.filters.categoryId !== "ALL"
    ) {
      var categoryName = findCategoryName(
        state.categories || [],
        state.filters.categoryId
      );

      if (categoryName && parts.indexOf(categoryName) === -1) {
        parts.push(categoryName);
      }
    }

    var brand = root.querySelector("[data-ua-catalog-brand]");
    var color = root.querySelector("[data-ua-catalog-color]");
    var size = root.querySelector("[data-ua-catalog-size]");

    [
      selectedOptionText(brand),
      selectedOptionText(color),
      selectedOptionText(size)
    ].forEach(function (value) {
      if (
        value &&
        !/^all\s/i.test(value) &&
        parts.indexOf(value) === -1
      ) {
        parts.push(value);
      }
    });

    var hasSearch = !!state.filters.search;
    var searchTerm = hasSearch
      ? String(state.filters.search).trim()
      : "";

    if (
      searchTerm &&
      parts.indexOf(searchTerm) === -1
    ) {
      parts.unshift(searchTerm);
    }

    var heading = hasSearch
      ? "Product Search"
      : "Products";

    if (parts.length) {
      heading += " - " + parts.join(" - ");
    }

    title.textContent = heading;

    if (!state.baseDocumentTitle) {
      state.baseDocumentTitle = document.title;
    }

    var suffix = state.baseDocumentTitle.indexOf(" – ") >= 0
      ? state.baseDocumentTitle.slice(
          state.baseDocumentTitle.indexOf(" – ")
        )
      : "";

    document.title = heading + suffix;
  }

  function escapePackageHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function renderManagedPackages(state, packages) {
    var shell = state.root.querySelector("[data-ua-catalog-packages-shell]");
    var list = state.root.querySelector("[data-ua-catalog-packages]");

    if (!shell || !list || !Array.isArray(packages) || !packages.length) {
      return false;
    }

    list.innerHTML = packages.map(function (item) {
      var destination = item.destinationType === "inquiry"
        ? "inquiry"
        : "products";

      return [
        '<button class="ua-catalog__package-button" type="button"',
        ' data-package-id="' + escapePackageHtml(item.id) + '"',
        ' data-package-destination="' + destination + '"',
        item.productTag
          ? ' data-package-tag="' + escapePackageHtml(item.productTag) + '"'
          : '',
        item.formUrl
          ? ' data-package-form-url="' + escapePackageHtml(item.formUrl) + '"'
          : '',
        item.formType
          ? ' data-package-form-type="' + escapePackageHtml(item.formType) + '"'
          : '',
        '><span>' + escapePackageHtml(item.label) + '</span></button>'
      ].join("");
    }).join("");

    shell.hidden = false;
    shell.setAttribute("data-package-source", "azure");
    state.packages = packages;
    updatePackageButtons(state);
    return true;
  }

  function updatePackageButtons(state) {
    var activeTag = String(state.filters.tag || "").toLowerCase();

    state.root.querySelectorAll("[data-package-tag]").forEach(function (button) {
      var buttonTag = String(
        button.getAttribute("data-package-tag") || ""
      ).toLowerCase();

      var active = !!activeTag && buttonTag === activeTag;

      button.classList.toggle("is-active", active);

      if (active) {
        button.setAttribute("aria-current", "page");
      } else {
        button.removeAttribute("aria-current");
      }
    });
  }

  function buildSelectedProductUrl(card, button) {
    var productId = card ? (card.getAttribute("data-product-id") || "") : "";
    if (!productId) return "";

    var existingLink = card.querySelector(".ua-catalog__image-link");
    var rawBase = existingLink
      ? (existingLink.getAttribute("href") || "")
      : "";

    var url;

    try {
      url = new URL(rawBase || "/pages/product-detail-v2", window.location.origin);
    } catch (_error) {
      return rawBase;
    }

    var styleId = button.getAttribute("data-style-id") || "";
    var colorName = button.getAttribute("data-color-name") || "";

    url.searchParams.set("productId", productId);

    if (styleId) {
      url.searchParams.set("styleId", styleId);
    } else {
      url.searchParams.delete("styleId");
    }

    if (colorName) {
      url.searchParams.set("selectedColor", colorName);
    } else {
      url.searchParams.delete("selectedColor");
    }

    url.searchParams.set(
      "returnUrl",
      window.location.pathname + window.location.search + window.location.hash
    );

    return url.pathname + url.search + url.hash;
  }

  function updateCardProductLinks(card, button) {
    var nextProductUrl = buildSelectedProductUrl(card, button);
    if (!nextProductUrl) return;

    card.querySelectorAll(
      ".ua-catalog__image-link, .ua-catalog__product-name a"
    ).forEach(function (link) {
      link.setAttribute("href", nextProductUrl);
    });
  }

  function setCardImageFromSwatch(button) {
    var card = button.closest("[data-ua-catalog-card]");
    var image = card
      ? card.querySelector("[data-ua-catalog-card-image]")
      : null;
    var nextUrl = button.getAttribute("data-image-url") || "";

    if (!card || !image || !nextUrl) return;

    card.querySelectorAll("[data-ua-catalog-swatch]").forEach(function (item) {
      var selected = item === button;
      item.classList.toggle("is-selected", selected);
      item.setAttribute("aria-pressed", selected ? "true" : "false");
    });

    updateCardProductLinks(card, button);

    if (image.currentSrc === nextUrl || image.src === nextUrl) {
      return;
    }

    var colorName = button.getAttribute("data-color-name") || "";
    var originalAlt = image.getAttribute("data-base-alt") || image.alt || "";

    if (!image.hasAttribute("data-base-alt")) {
      image.setAttribute("data-base-alt", originalAlt);
    }

    card.classList.add("is-image-changing");

    var requestToken = String(Date.now()) + Math.random();
    card.setAttribute("data-image-request", requestToken);

    if (card._uaPreloader) {
      card._uaPreloader.onload = null;
      card._uaPreloader.onerror = null;
      card._uaPreloader.src = "";
    }

    var preloader = new Image();
    card._uaPreloader = preloader;
    var completed = false;
    var timer = 0;

    function cleanup() {
      window.clearTimeout(timer);
      preloader.onload = null;
      preloader.onerror = null;

      if (card._uaPreloader === preloader) {
        card._uaPreloader = null;
      }
    }

    function finish(success) {
      if (completed) return;
      completed = true;

      if (card.getAttribute("data-image-request") !== requestToken) {
        cleanup();
        return;
      }

      if (success) {
        image.src = nextUrl;
        image.alt = colorName
          ? originalAlt + " - " + colorName
          : originalAlt;
      }

      cleanup();

      window.requestAnimationFrame(function () {
        card.classList.remove("is-image-changing");
      });
    }

    preloader.onload = function () {
      finish(true);
    };

    preloader.onerror = function () {
      finish(false);
    };

    preloader.src = nextUrl;

    if (preloader.complete && preloader.naturalWidth > 0) {
      finish(true);
      return;
    }

    timer = window.setTimeout(function () {
      finish(preloader.complete && preloader.naturalWidth > 0);
    }, 6000);
  }


  function normalizeSearchPhrase(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/&/g, " and ")
      .replace(/[_-]+/g, " ")
      .replace(/[^a-z0-9\s]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function packageButtonText(button) {
    return normalizeSearchPhrase(
      [
        button.getAttribute("data-package-id") || "",
        button.getAttribute("data-package-form-type") || "",
        button.textContent || ""
      ].join(" ")
    );
  }

  function findManagedPackageButton(state, aliases) {
    var normalizedAliases = aliases.map(normalizeSearchPhrase);
    var buttons = state.root.querySelectorAll(
      "[data-package-destination], [data-package-tag]"
    );

    for (var i = 0; i < buttons.length; i += 1) {
      var button = buttons[i];
      var haystack = packageButtonText(button);

      for (var j = 0; j < normalizedAliases.length; j += 1) {
        var alias = normalizedAliases[j];

        if (
          haystack === alias ||
          haystack.indexOf(alias) >= 0
        ) {
          return button;
        }
      }
    }

    return null;
  }

  function openInquiryPackage(state, packageButton) {
    var formUrl =
      packageButton.getAttribute("data-package-form-url") || "";
    var formType =
      packageButton.getAttribute("data-package-form-type") || "";
    var packageName =
      String(packageButton.textContent || "").trim();
    var rfqType = "";

    if (formUrl) {
      try {
        var parsedFormUrl = new URL(
          formUrl,
          window.location.origin
        );

        rfqType =
          parsedFormUrl.searchParams.get("rfq_type") ||
          parsedFormUrl.searchParams.get("rfqType") ||
          parsedFormUrl.searchParams.get("type") ||
          "";
      } catch (_error) {
        rfqType = "";
      }
    }

    var quoteContext = {
      rfqType: rfqType || formType || "general",
      quoteType: rfqType || formType || "general",
      packageName: packageName,
      productName: packageName,
      sourcePageUrl: window.location.href,
      quantity: 1
    };

    if (
      window.UnisourceQuoteModal &&
      typeof window.UnisourceQuoteModal.open === "function"
    ) {
      window.UnisourceQuoteModal.open(quoteContext);
      return true;
    }

    document.dispatchEvent(
      new CustomEvent("unisource:open-quote", {
        bubbles: true,
        detail: {
          source: "catalog-package",
          rfqType: quoteContext.rfqType,
          quoteType: quoteContext.quoteType,
          packageName: packageName,
          productName: packageName,
          sourcePageUrl: window.location.href,
          quantity: 1,
          href: formUrl
        }
      })
    );

    window.setTimeout(function () {
      var modalOpened =
        document.body.classList.contains("uqm-open") ||
        document.body.classList.contains(
          "unisource-quote-modal-open"
        ) ||
        document.querySelector(
          "#unisource-quote-modal.is-open"
        ) ||
        document.querySelector(
          ".unisource-quote-modal.is-open"
        ) ||
        document.querySelector(
          "[data-unisource-quote-modal].is-open"
        );

      if (!modalOpened && formUrl) {
        window.location.href = formUrl;
      }
    }, 80);

    return true;
  }

  function activateProductPackage(
    state,
    packageButton,
    searchInput,
    updateSearchClearButton
  ) {
    state.filters.tag =
      packageButton.getAttribute("data-package-tag") || "";
    state.filters.categoryId = "ALL";
    state.filters.brand = "";
    state.filters.color = "";
    state.filters.size = "";
    state.filters.search = "";
    state.smartSearchLabel = "";
    state.page = 1;

    searchInput.value = "";
    updateSearchClearButton();
    window.UA_CATALOG.render.categories(state);
    updatePackageButtons(state);
    updateDynamicTitle(state);
    resetCategoryScroll(state);
    load(state, { keepCards: true });

    if (window.matchMedia("(max-width: 749px)").matches) {
      setSidebarOpen(state, false);
    }
  }

  function handleSmartSearch(
    state,
    rawTerm,
    searchInput,
    updateSearchClearButton
  ) {
    var term = normalizeSearchPhrase(rawTerm);
    var packageButton = null;

    if (!term) return false;

    if (
      [
        "on sale",
        "sale",
        "sales",
        "special",
        "specials"
      ].indexOf(term) >= 0
    ) {
      state.filters.tag = "curated_on_sale";
      state.filters.categoryId = "ALL";
      state.filters.brand = "";
      state.filters.color = "";
      state.filters.size = "";
      state.filters.search = "";
      state.smartSearchLabel = "On Sale";
      state.page = 1;

      searchInput.value = "";
      updateSearchClearButton();
      window.UA_CATALOG.render.categories(state);
      updatePackageButtons(state);
      resetCategoryScroll(state);
      load(state, { keepCards: true });
      return true;
    }

    if (
      [
        "package",
        "packages",
        "package deal",
        "package deals",
        "deal",
        "deals"
      ].indexOf(term) >= 0
    ) {
      packageButton = findManagedPackageButton(
        state,
        ["package-deals", "package deals"]
      );
    } else if (
      [
        "graduation",
        "graduation package",
        "graduation packages",
        "grad package",
        "grad packages"
      ].indexOf(term) >= 0
    ) {
      packageButton = findManagedPackageButton(
        state,
        ["graduation", "graduation packages"]
      );
    } else if (
      [
        "spirit wear",
        "spiritwear",
        "spirit wear package",
        "spirit wear packages"
      ].indexOf(term) >= 0
    ) {
      packageButton = findManagedPackageButton(
        state,
        ["spirit-wear", "spirit wear packages"]
      );
    } else if (
      [
        "pe package",
        "pe packages",
        "pe uniform",
        "pe uniforms",
        "pe uniform package",
        "pe uniform packages",
        "physical education package"
      ].indexOf(term) >= 0
    ) {
      packageButton = findManagedPackageButton(
        state,
        ["pe package", "pe uniform", "school"]
      );
    } else if (
      [
        "sportswear package",
        "sportswear packages",
        "sublimated",
        "sublimation",
        "sublimated apparel",
        "sublimated apparel package"
      ].indexOf(term) >= 0
    ) {
      packageButton = findManagedPackageButton(
        state,
        ["sportswear", "sublimated apparel"]
      );
    } else if (
      [
        "grad stole",
        "grad stole package",
        "grad stole packages",
        "stole package",
        "stole packages",
        "graduation stole"
      ].indexOf(term) >= 0
    ) {
      packageButton = findManagedPackageButton(
        state,
        ["grad-stole", "grad stole packages"]
      );
    }

    if (!packageButton) return false;

    var destination =
      packageButton.getAttribute("data-package-destination") ||
      "products";

    if (destination === "inquiry") {
      return openInquiryPackage(state, packageButton);
    }

    activateProductPackage(
      state,
      packageButton,
      searchInput,
      updateSearchClearButton
    );

    return true;
  }

  function ensureCompareStyles() {
    if (document.getElementById("ua-catalog-compare-styles")) return;

    var style = document.createElement("style");
    style.id = "ua-catalog-compare-styles";
    style.textContent = `
      .ua-catalog__compare-control {
        display: none;
        margin: 0 0 10px;
      }

      .ua-catalog__compare-button {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 0;
        border: 0;
        background: transparent;
        color: #183b73;
        font: inherit;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
      }

      .ua-catalog__compare-box {
        width: 18px;
        height: 18px;
        border: 2px solid #9eb1cb;
        border-radius: 5px;
        background: #fff;
        box-sizing: border-box;
        position: relative;
      }

      .ua-catalog__compare-button.is-selected .ua-catalog__compare-box {
        border-color: #173f7a;
        background: #173f7a;
      }

      .ua-catalog__compare-button.is-selected .ua-catalog__compare-box::after {
        content: "";
        position: absolute;
        left: 5px;
        top: 2px;
        width: 4px;
        height: 8px;
        border: solid #fff;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
      }

      .ua-catalog-compare-tray {
        display: none;
      }

      .ua-catalog-compare-modal[hidden] {
        display: none !important;
      }

      @media (min-width: 750px) {
        .ua-catalog__compare-control {
          display: block;
        }

        .ua-catalog-compare-tray {
          position: fixed;
          left: 50%;
          bottom: 74px;
          z-index: 2147482000;
          width: min(760px, calc(100vw - 48px));
          transform: translateX(-50%);
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          padding: 14px 16px;
          border: 1px solid #d7e0ec;
          border-radius: 16px;
          background: #fff;
          box-shadow: 0 18px 50px rgba(15, 37, 72, .22);
        }

        .ua-catalog-compare-tray.is-visible {
          display: flex;
        }

        .ua-catalog-compare-tray__summary {
          min-width: 0;
        }

        .ua-catalog-compare-tray__summary strong {
          display: block;
          color: #10213d;
          font-size: 15px;
        }

        .ua-catalog-compare-tray__summary span {
          display: block;
          margin-top: 2px;
          color: #60708a;
          font-size: 12px;
        }

        .ua-catalog-compare-tray__items {
          display: flex;
          align-items: center;
          gap: 8px;
          min-width: 0;
          flex: 1 1 auto;
        }

        .ua-catalog-compare-tray__chip {
          display: flex;
          align-items: center;
          gap: 7px;
          min-width: 0;
          max-width: 170px;
          padding: 5px 8px 5px 5px;
          border: 1px solid #d7e0ec;
          border-radius: 999px;
          background: #f8fafc;
        }

        .ua-catalog-compare-tray__chip img {
          width: 28px;
          height: 28px;
          object-fit: contain;
          border-radius: 50%;
          background: #fff;
        }

        .ua-catalog-compare-tray__chip span {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #24364f;
          font-size: 11px;
          font-weight: 700;
        }

        .ua-catalog-compare-tray__chip button {
          flex: 0 0 auto;
          border: 0;
          background: transparent;
          color: #66758c;
          font-size: 16px;
          cursor: pointer;
        }

        .ua-catalog-compare-tray__actions {
          display: flex;
          gap: 8px;
          flex: 0 0 auto;
        }

        .ua-catalog-compare-tray__actions button {
          min-height: 38px;
          padding: 0 14px;
          border-radius: 9px;
          font: inherit;
          font-size: 13px;
          font-weight: 800;
          cursor: pointer;
        }

        .ua-catalog-compare-tray__clear {
          border: 1px solid #b8c6d9;
          background: #fff;
          color: #173f7a;
        }

        .ua-catalog-compare-tray__open {
          border: 1px solid #173f7a;
          background: #173f7a;
          color: #fff;
        }

        .ua-catalog-compare-tray__open:disabled {
          opacity: .45;
          cursor: not-allowed;
        }

        .ua-catalog-compare-modal {
          position: fixed;
          inset: 0;
          z-index: 2147483000;
        }

        .ua-catalog-compare-modal__backdrop {
          position: absolute;
          inset: 0;
          background: rgba(8, 20, 40, .72);
        }

        .ua-catalog-compare-modal__dialog {
          position: absolute;
          inset: 34px;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          border-radius: 18px;
          background: #fff;
          box-shadow: 0 28px 90px rgba(0, 0, 0, .34);
        }

        .ua-catalog-compare-modal__header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 18px 22px;
          border-bottom: 1px solid #dfe6ef;
        }

        .ua-catalog-compare-modal__header h2 {
          margin: 0;
          color: #10213d;
          font-size: 24px;
        }

        .ua-catalog-compare-modal__close {
          width: 42px;
          height: 42px;
          border: 1px solid #cbd5e1;
          border-radius: 50%;
          background: #fff;
          color: #10213d;
          font-size: 23px;
          cursor: pointer;
        }

        .ua-catalog-compare-modal__body {
          flex: 1 1 auto;
          overflow: auto;
          padding: 22px;
        }

        .ua-catalog-compare-grid {
          display: grid;
          grid-template-columns: repeat(var(--ua-compare-count), minmax(220px, 1fr));
          gap: 0;
          min-width: calc(var(--ua-compare-count) * 250px);
          border: 1px solid #dfe6ef;
          border-radius: 14px;
          overflow: hidden;
        }

        .ua-catalog-compare-column {
          min-width: 0;
          border-right: 1px solid #dfe6ef;
        }

        .ua-catalog-compare-column:last-child {
          border-right: 0;
        }

        .ua-catalog-compare-column__top {
          position: relative;
          min-height: 310px;
          padding: 18px;
          text-align: center;
          background: #f8fafc;
        }

        .ua-catalog-compare-column__remove {
          position: absolute;
          top: 12px;
          right: 12px;
          width: 32px;
          height: 32px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #cbd5e1;
          border-radius: 50%;
          background: #ffffff;
          color: #41516a;
          font-size: 18px;
          line-height: 1;
          cursor: pointer;
        }

        .ua-catalog-compare-column__remove:hover {
          background: #eef3f8;
          color: #10213d;
        }

        .ua-catalog-compare-swatches {
          display: flex;
          flex-wrap: wrap;
          gap: 7px;
          align-items: center;
        }

        .ua-catalog-compare-swatch {
          width: 22px;
          height: 22px;
          flex: 0 0 auto;
          border: 2px solid #ffffff;
          border-radius: 50%;
          box-shadow: 0 0 0 1px #aebbd0;
        }

        .ua-catalog-compare-swatch-more {
          color: #60708a;
          font-size: 12px;
          font-weight: 700;
        }

        .ua-catalog-compare-column__top img {
          width: 100%;
          height: 190px;
          object-fit: contain;
        }

        .ua-catalog-compare-column__top h3 {
          margin: 12px 0 4px;
          color: #10213d;
          font-size: 17px;
          line-height: 1.3;
        }

        .ua-catalog-compare-column__top p {
          margin: 0;
          color: #60708a;
          font-size: 13px;
          font-weight: 700;
        }

        .ua-catalog-compare-row {
          min-height: 62px;
          padding: 13px 16px;
          border-top: 1px solid #dfe6ef;
        }

        .ua-catalog-compare-row strong {
          display: block;
          margin-bottom: 5px;
          color: #60708a;
          font-size: 11px;
          letter-spacing: .04em;
          text-transform: uppercase;
        }

        .ua-catalog-compare-row span {
          color: #10213d;
          font-size: 13px;
          line-height: 1.45;
        }

        .ua-catalog-compare-row--description {
          min-height: 120px;
        }

        .ua-catalog-compare-row--description span {
          display: block;
          max-height: 150px;
          overflow: auto;
          padding-right: 4px;
          line-height: 1.55;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function compareEscape(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function readComparePayload(button) {
    try {
      return JSON.parse(
        button.getAttribute("data-compare-product") || "{}"
      );
    } catch (_error) {
      return null;
    }
  }

  function compareItems(state) {
    return Object.keys(state.compareSelected || {}).map(function (id) {
      return state.compareSelected[id];
    });
  }

  function ensureCompareUi(state) {
    ensureCompareStyles();

    if (!state.compareSelected) {
      state.compareSelected = {};
    }

    if (!state.compareOrder) {
      state.compareOrder = [];
    }

    if (!document.querySelector("[data-ua-compare-tray]")) {
      var tray = document.createElement("div");
      tray.className = "ua-catalog-compare-tray";
      tray.setAttribute("data-ua-compare-tray", "");
      tray.innerHTML = [
        '<div class="ua-catalog-compare-tray__summary">',
          '<strong data-ua-compare-count>0 of 3 selected</strong>',
          '<span>Select 2 or 3 apparel items to compare.</span>',
        '</div>',
        '<div class="ua-catalog-compare-tray__items" data-ua-compare-items></div>',
        '<div class="ua-catalog-compare-tray__actions">',
          '<button class="ua-catalog-compare-tray__clear" type="button" data-ua-compare-clear>Clear</button>',
          '<button class="ua-catalog-compare-tray__open" type="button" data-ua-compare-open disabled>Compare</button>',
        '</div>'
      ].join("");

      document.body.appendChild(tray);
    }

    if (!document.querySelector("[data-ua-compare-modal]")) {
      var modal = document.createElement("section");
      modal.className = "ua-catalog-compare-modal";
      modal.setAttribute("data-ua-compare-modal", "");
      modal.setAttribute("aria-hidden", "true");
      modal.hidden = true;
      modal.innerHTML = [
        '<div class="ua-catalog-compare-modal__backdrop" data-ua-compare-close></div>',
        '<div class="ua-catalog-compare-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="ua-compare-title">',
          '<header class="ua-catalog-compare-modal__header">',
            '<div><p style="margin:0 0 3px;color:#60708a;font-size:12px;font-weight:800;letter-spacing:.06em;text-transform:uppercase">Apparel comparison</p>',
            '<h2 id="ua-compare-title">Compare selected apparel</h2></div>',
            '<button class="ua-catalog-compare-modal__close" type="button" aria-label="Close comparison" data-ua-compare-close>×</button>',
          '</header>',
          '<div class="ua-catalog-compare-modal__body" data-ua-compare-modal-body></div>',
        '</div>'
      ].join("");

      document.body.appendChild(modal);
    }
  }

  function syncCompareButtons(state) {
    state.root.querySelectorAll("[data-ua-catalog-compare]").forEach(function (button) {
      var payload = readComparePayload(button);
      var selected = !!(
        payload &&
        state.compareSelected &&
        state.compareSelected[String(payload.id)]
      );

      button.classList.toggle("is-selected", selected);
      button.setAttribute("aria-pressed", selected ? "true" : "false");
      button.querySelector("span:last-child").textContent =
        selected ? "Selected for comparison" : "Compare apparel";
    });
  }

  function renderCompareTray(state) {
    ensureCompareUi(state);

    var tray = document.querySelector("[data-ua-compare-tray]");
    var count = tray.querySelector("[data-ua-compare-count]");
    var itemsWrap = tray.querySelector("[data-ua-compare-items]");
    var openButton = tray.querySelector("[data-ua-compare-open]");
    var items = state.compareOrder
      .map(function (id) {
        return state.compareSelected[id];
      })
      .filter(Boolean);

    tray.classList.toggle("is-visible", items.length > 0);
    count.textContent = items.length + " of 3 selected";
    openButton.disabled = items.length < 2;

    itemsWrap.innerHTML = items.map(function (item) {
      return [
        '<div class="ua-catalog-compare-tray__chip">',
          item.imageUrl
            ? '<img src="' + compareEscape(item.imageUrl) + '" alt="">'
            : '',
          '<span>' + compareEscape(item.name) + '</span>',
          '<button type="button" aria-label="Remove ' + compareEscape(item.name) + '" data-ua-compare-remove="' + compareEscape(item.id) + '">×</button>',
        '</div>'
      ].join("");
    }).join("");

    syncCompareButtons(state);
  }

  function compareValueList(values, limit) {
    var list = Array.isArray(values) ? values.filter(Boolean) : [];

    if (!list.length) return "—";

    var shown = list.slice(0, limit || 8);
    var suffix = list.length > shown.length
      ? " +" + (list.length - shown.length) + " more"
      : "";

    return shown.join(", ") + suffix;
  }

  function compareSwatchStyle(color) {
    var first = String(color && color.hex1 || "#d9dee6");
    var second = String(color && color.hex2 || "");

    if (second) {
      return (
        "background:linear-gradient(135deg," +
        first +
        " 0 50%," +
        second +
        " 50% 100%)"
      );
    }

    return "background:" + first;
  }

  function compareDescriptionCandidate(product) {
    if (!product || typeof product !== "object") {
      return "";
    }

    return String(
      product.description ||
      product.Description ||
      product.productDescription ||
      product.ProductDescription ||
      product.details ||
      product.Details ||
      product.longDescription ||
      product.LongDescription ||
      ""
    ).trim();
  }

  function compareProductDetailEndpoint(state) {
    return (
      state.productDetailEndpoint ||
      state.root.getAttribute("data-product-detail-endpoint") ||
      "https://shopify-inksoft-poc-node.azurewebsites.net/api/poc/product"
    );
  }

  async function loadCompareDescription(state, item) {
    if (!item || !item.id) return "";

    var endpoint = compareProductDetailEndpoint(state);
    var url = new URL(endpoint, window.location.origin);

    url.searchParams.set("id", String(item.id));

    var response = await fetch(url.toString(), {
      method: "GET",
      headers: {
        "Accept": "application/json"
      },
      credentials: "omit",
      cache: "no-store"
    });

    if (!response.ok) {
      throw new Error(
        "Product detail request failed with status " +
        response.status
      );
    }

    var payload = await response.json();
    var data =
      payload && payload.data
        ? payload.data
        : payload;

    var product =
      data && data.product
        ? data.product
        : data;

    return compareDescriptionCandidate(product);
  }

  function hydrateCompareDescriptions(state) {
    var items = state.compareOrder
      .map(function (id) {
        return state.compareSelected[id];
      })
      .filter(Boolean);

    var pending = items.filter(function (item) {
      return !compareDescriptionCandidate(item);
    });

    if (!pending.length) return;

    pending.forEach(function (item) {
      item.descriptionLoading = true;
    });

    renderCompareModalBody(state);

    Promise.all(
      pending.map(function (item) {
        return loadCompareDescription(state, item)
          .then(function (description) {
            item.description = description || "";
            item.descriptionLoading = false;
            item.descriptionLoaded = true;
          })
          .catch(function (error) {
            item.description = "";
            item.descriptionLoading = false;
            item.descriptionLoaded = true;

            console.warn(
              "[UA Catalog Compare] Unable to load product description.",
              {
                productId: item.id,
                error: error
              }
            );
          });
      })
    ).then(function () {
      var modal = document.querySelector(
        "[data-ua-compare-modal]"
      );

      if (modal && !modal.hidden) {
        renderCompareModalBody(state);
      }
    });
  }

  function compareDescriptionText(value) {
    var container = document.createElement("div");
    container.innerHTML = String(value || "");

    return String(
      container.textContent ||
      container.innerText ||
      ""
    )
      .replace(/\s+/g, " ")
      .trim();
  }

  function compareColorSwatches(colors, limit) {
    var list = Array.isArray(colors) ? colors.filter(function (color) {
      return color && color.name;
    }) : [];

    if (!list.length) {
      return '<span>—</span>';
    }

    var shown = list.slice(0, limit || 12);
    var more = list.length - shown.length;

    return [
      '<div class="ua-catalog-compare-swatches" aria-label="Available colors">',
      shown.map(function (color) {
        return [
          '<span',
          ' class="ua-catalog-compare-swatch"',
          ' title="' + compareEscape(color.name) + '"',
          ' aria-label="' + compareEscape(color.name) + '"',
          ' style="' + compareSwatchStyle(color) + '"',
          '></span>'
        ].join("");
      }).join(""),
      more > 0
        ? '<span class="ua-catalog-compare-swatch-more">+' + more + ' more</span>'
        : '',
      '</div>'
    ].join("");
  }

  function renderCompareModalBody(state) {
    var modal = document.querySelector("[data-ua-compare-modal]");
    if (!modal) return;

    var body = modal.querySelector("[data-ua-compare-modal-body]");
    var items = state.compareOrder
      .map(function (id) {
        return state.compareSelected[id];
      })
      .filter(Boolean);

    if (items.length < 2) {
      closeCompareModal();
      return;
    }

    body.innerHTML = [
      '<div class="ua-catalog-compare-grid" style="--ua-compare-count:' + items.length + '">',
      items.map(function (item) {
        return [
          '<article class="ua-catalog-compare-column">',
            '<div class="ua-catalog-compare-column__top">',
              '<button class="ua-catalog-compare-column__remove" type="button"',
              ' aria-label="Remove ' + compareEscape(item.name) + ' from comparison"',
              ' data-ua-compare-remove="' + compareEscape(item.id) + '">×</button>',
              item.imageUrl
                ? '<img src="' + compareEscape(item.imageUrl) + '" alt="' + compareEscape(item.name) + '">'
                : '',
              '<h3>' + compareEscape(item.name) + '</h3>',
              '<p>' + compareEscape(item.brand || "—") + '</p>',
            '</div>',
            '<div class="ua-catalog-compare-row"><strong>SKU</strong><span>' + compareEscape(item.sku || "—") + '</span></div>',
            '<div class="ua-catalog-compare-row"><strong>Manufacturer SKU</strong><span>' + compareEscape(item.manufacturerSku || "—") + '</span></div>',
            '<div class="ua-catalog-compare-row"><strong>Selected color</strong><span>' + compareEscape(item.selectedColor || "—") + '</span></div>',
            '<div class="ua-catalog-compare-row"><strong>Available colors</strong>' + compareColorSwatches(item.colors, 12) + '</div>',
            '<div class="ua-catalog-compare-row"><strong>Available sizes</strong><span>' + compareEscape(compareValueList(item.sizes, 12)) + '</span></div>',
            '<div class="ua-catalog-compare-row ua-catalog-compare-row--description"><strong>Product description</strong><span>' + compareEscape(
              item.descriptionLoading
                ? "Loading product description…"
                : compareDescriptionText(item.description) || "Description unavailable."
            ) + '</span></div>',
          '</article>'
        ].join("");
      }).join(""),
      '</div>'
    ].join("");
  }

  function openCompareModal(state) {
    var items = state.compareOrder
      .map(function (id) {
        return state.compareSelected[id];
      })
      .filter(Boolean);

    if (items.length < 2) return;

    var modal = document.querySelector("[data-ua-compare-modal]");

    renderCompareModalBody(state);

    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";

    hydrateCompareDescriptions(state);
  }

  function closeCompareModal() {
    var modal = document.querySelector("[data-ua-compare-modal]");
    if (!modal) return;

    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.style.removeProperty("overflow");
  }

  function removeCompareItem(state, id) {
    id = String(id || "");

    delete state.compareSelected[id];
    state.compareOrder = state.compareOrder.filter(function (itemId) {
      return String(itemId) !== id;
    });

    renderCompareTray(state);

    var modal = document.querySelector("[data-ua-compare-modal]");

    if (modal && !modal.hidden) {
      renderCompareModalBody(state);
    }
  }

  function toggleCompareItem(state, button) {
    var item = readComparePayload(button);
    if (!item || !item.id) return;

    var id = String(item.id);

    if (state.compareSelected[id]) {
      removeCompareItem(state, id);
      return;
    }

    if (state.compareOrder.length >= 3) {
      window.alert("You can compare up to 3 apparel items.");
      return;
    }

    state.compareSelected[id] = item;
    state.compareOrder.push(id);
    renderCompareTray(state);
  }

  function bind(state) {
    var root = state.root;
    var searchForm = root.querySelector("[data-ua-catalog-search-form]");
    var searchInput = root.querySelector("[data-ua-catalog-search]");
    var searchClear = root.querySelector("[data-ua-catalog-search-clear]");
    var brand = root.querySelector("[data-ua-catalog-brand]");
    var color = root.querySelector("[data-ua-catalog-color]");
    var size = root.querySelector("[data-ua-catalog-size]");
    var clear = root.querySelector("[data-ua-catalog-clear]");
    var previous = root.querySelector("[data-ua-catalog-previous]");
    var next = root.querySelector("[data-ua-catalog-next]");
    var toggle = root.querySelector("[data-ua-catalog-filter-toggle]");
    var sidebar = root.querySelector("[data-ua-catalog-sidebar]");
    var sidebarClose = root.querySelector("[data-ua-catalog-sidebar-close]");
    var sidebarBackdrop = root.querySelector("[data-ua-catalog-sidebar-backdrop]");
    var categoryScroller = root.querySelector("[data-ua-catalog-categories-scroll]");
    var categoryScrollUp = root.querySelector("[data-ua-catalog-categories-up]");
    var categoryScrollDown = root.querySelector("[data-ua-catalog-categories-down]");

    function updateSearchClearButton() {
      if (!searchClear) return;

      searchClear.hidden = !String(searchInput.value || "").trim();
    }

    searchInput.value = state.filters.search;
    updateSearchClearButton();

    searchInput.addEventListener("input", function () {
      updateSearchClearButton();
    });

    if (searchClear) {
      searchClear.addEventListener("click", function () {
        if (state.loading) return;

        searchInput.value = "";
        state.filters.search = "";
        state.smartSearchLabel = "";
        state.page = 1;

        updateSearchClearButton();
        searchInput.focus();
        load(state, { keepCards: true });
      });
    }

    searchForm.addEventListener("submit", function (event) {
      event.preventDefault();

      var submittedTerm =
        String(searchInput.value || "").trim();

      /*
       * Every new search starts from a clean catalogue state.
       * This prevents a previous package, smart-search tag, category,
       * brand, color, or size filter from being combined silently
       * with the replacement search term.
       */
      state.filters.categoryId = "ALL";
      state.filters.brand = "";
      state.filters.color = "";
      state.filters.size = "";
      state.filters.search = "";
      state.filters.tag = "";
      state.smartSearchLabel = "";
      state.page = 1;

      window.UA_CATALOG.render.categories(state);
      updatePackageButtons(state);
      resetCategoryScroll(state);

      if (
        handleSmartSearch(
          state,
          submittedTerm,
          searchInput,
          updateSearchClearButton
        )
      ) {
        return;
      }

      state.filters.search = submittedTerm;
      updateSearchClearButton();
      updateDynamicTitle(state);
      load(state);
    });

    [
      [brand, "brand"],
      [color, "color"],
      [size, "size"]
    ].forEach(function (entry) {
      entry[0].addEventListener("change", function () {
        state.filters[entry[1]] = entry[0].value;
        state.page = 1;
        load(state);
      });
    });

    clear.addEventListener("click", function () {
      state.filters.brand = "";
      state.filters.color = "";
      state.filters.size = "";
      state.filters.search = "";
      state.smartSearchLabel = "";
      state.page = 1;
      searchInput.value = "";
      updateSearchClearButton();
      load(state);
    });

    previous.addEventListener("click", function () {
      if (state.loading || state.page <= 1) return;
      state.page -= 1;
      load(state, { keepCards: true });
      root.scrollIntoView({ behavior: "smooth", block: "start" });
    });

    next.addEventListener("click", function () {
      if (state.loading || state.page >= state.totalPages) return;
      state.page += 1;
      load(state, { keepCards: true });
      root.scrollIntoView({ behavior: "smooth", block: "start" });
    });

    root.addEventListener("click", function (event) {
      var compareButton = event.target && event.target.closest
        ? event.target.closest("[data-ua-catalog-compare]")
        : null;

      if (compareButton && root.contains(compareButton)) {
        event.preventDefault();
        event.stopPropagation();
        toggleCompareItem(state, compareButton);
        return;
      }

      var swatchButton = event.target && event.target.closest
        ? event.target.closest("[data-ua-catalog-swatch]")
        : null;

      if (swatchButton && root.contains(swatchButton)) {
        event.preventDefault();
        event.stopPropagation();
        setCardImageFromSwatch(swatchButton);
        return;
      }

      /*
       * Product packages have data-package-tag. Inquiry packages intentionally
       * have no product tag, so they must also be detected by their destination
       * attribute.
       */
      var packageButton = event.target && event.target.closest
        ? event.target.closest(
            "[data-package-destination], [data-package-tag]"
          )
        : null;

      if (packageButton && root.contains(packageButton) && !state.loading) {
        var destination =
          packageButton.getAttribute("data-package-destination") || "products";

        if (destination === "inquiry") {
          openInquiryPackage(state, packageButton);
          return;
        }

        activateProductPackage(
          state,
          packageButton,
          searchInput,
          updateSearchClearButton
        );

        return;
      }

      var expandButton = event.target && event.target.closest
        ? event.target.closest("[data-category-toggle]")
        : null;

      if (expandButton && root.contains(expandButton)) {
        var expandId = String(
          expandButton.getAttribute("data-category-toggle") || ""
        );

        var currentlyExpanded =
          expandButton.getAttribute("aria-expanded") === "true";

        state.expandedCategoryIds[expandId] =
          !currentlyExpanded;

        window.UA_CATALOG.render.categories(state);
        updatePackageButtons(state);
        updateDynamicTitle(state);
        resetCategoryScroll(state);
        return;
      }

      var button = event.target && event.target.closest
        ? event.target.closest("[data-category-id]")
        : null;

      if (!button || !root.contains(button) || state.loading) return;

      state.filters.categoryId =
        button.getAttribute("data-category-id") || "ALL";

      /*
       * Package Deals is a merchandising scope, not a replacement category.
       * Preserve that tag while the shopper drills into Sweatshirts, T-Shirts,
       * etc. Other smart/curated tags keep their previous replacement behavior.
       */
      if (!isPackageDealsTag(state.filters.tag)) {
        state.filters.tag = "";
      }

      state.smartSearchLabel = "";
      state.page = 1;

      openSelectedCategoryBranch(state);
      window.UA_CATALOG.render.categories(state);
      updatePackageButtons(state);
      updateDynamicTitle(state);

      if (state.filters.categoryId === "ALL") {
        resetCategoryScroll(state);
      } else {
        queueCategoryScrollButtonUpdate(state);
      }

      load(state, { keepCards: true });

      if (window.matchMedia("(max-width: 749px)").matches) {
        setSidebarOpen(state, false);
      }
    });

    toggle.addEventListener("click", function () {
      setSidebarOpen(state, !sidebar.classList.contains("is-open"));
    });

    if (sidebarClose) {
      sidebarClose.addEventListener("click", function () {
        setSidebarOpen(state, false);
      });
    }

    if (sidebarBackdrop) {
      sidebarBackdrop.addEventListener("click", function () {
        setSidebarOpen(state, false);
      });
    }

    if (categoryScrollUp) {
      categoryScrollUp.addEventListener("click", function () {
        scrollCategories(state, -1);
      });
    }

    if (categoryScrollDown) {
      categoryScrollDown.addEventListener("click", function () {
        scrollCategories(state, 1);
      });
    }

    if (categoryScroller) {
      categoryScroller.addEventListener(
        "scroll",
        function () {
          window.requestAnimationFrame(function () {
            updateCategoryScrollButtons(state);
          });
        },
        { passive: true }
      );
    }

    if (categoryScroller && "ResizeObserver" in window) {
      var categoryResizeObserver = new ResizeObserver(function () {
        queueCategoryScrollButtonUpdate(state);
      });

      categoryResizeObserver.observe(categoryScroller);
    }

    var categoryList = root.querySelector("[data-ua-catalog-categories]");

    if (categoryList && "MutationObserver" in window) {
      var categoryMutationObserver = new MutationObserver(function () {
        queueCategoryScrollButtonUpdate(state);
      });

      categoryMutationObserver.observe(categoryList, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["hidden", "class", "aria-expanded"]
      });
    }

    document.addEventListener("click", function (event) {
      var removeButton = event.target && event.target.closest
        ? event.target.closest("[data-ua-compare-remove]")
        : null;

      if (removeButton) {
        removeCompareItem(
          state,
          removeButton.getAttribute("data-ua-compare-remove")
        );
        return;
      }

      if (
        event.target &&
        event.target.closest &&
        event.target.closest("[data-ua-compare-clear]")
      ) {
        state.compareSelected = {};
        state.compareOrder = [];
        renderCompareTray(state);
        return;
      }

      if (
        event.target &&
        event.target.closest &&
        event.target.closest("[data-ua-compare-open]")
      ) {
        openCompareModal(state);
        return;
      }

      if (
        event.target &&
        event.target.closest &&
        event.target.closest("[data-ua-compare-close]")
      ) {
        closeCompareModal();
      }
    });

    window.addEventListener("resize", function () {
      queueCategoryScrollButtonUpdate(state);

      if (window.matchMedia("(max-width: 749px)").matches) {
        closeCompareModal();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;

      var compareModal = document.querySelector("[data-ua-compare-modal]");

      if (compareModal && !compareModal.hidden) {
        closeCompareModal();
        return;
      }

      if (sidebar.classList.contains("is-open")) {
        setSidebarOpen(state, false);
        toggle.focus();
      }
    });
  }

  function restoreAfterSafariReturn(state) {
    state.root.querySelector("[data-ua-catalog-grid]").setAttribute("aria-busy", "false");

    if (!state.currentResponse && !state.loading) {
      load(state);
    }
  }

  function init(root) {
    if (root.dataset.uaCatalogReady === "true") return;
    root.dataset.uaCatalogReady = "true";

    var state = window.UA_CATALOG.createState(root);
    state.packagesEndpoint = root.dataset.packagesEndpoint || "";
    state.compareSelected = {};
    state.compareOrder = [];
    ensureCompareUi(state);
    state.smartSearchLabel = "";
    readUrlState(state);
    bind(state);

    /*
     * Load the catalogue immediately.
     * Categories are independent and must not delay the first product page.
     */
    load(state);

    /*
     * Package configuration is independent. If it fails, the Shopify block
     * fallback remains visible and the current catalogue behavior is preserved.
     */
    window.UA_CATALOG.api.loadPackages(state)
      .then(function (packages) {
        renderManagedPackages(state, packages);
      })
      .catch(function (error) {
        console.error("[UA Catalog Packages]", error);
      });

    window.UA_CATALOG.api.loadCategories(state)
      .then(function (categories) {
        state.categories = categories;
        openSelectedCategoryBranch(state);
        window.UA_CATALOG.render.categories(state);
        queueCategoryScrollButtonUpdate(state);
      })
      .catch(function (error) {
        console.error("[UA Catalog Categories]", error);
      });

    window.addEventListener("pageshow", function () {
      restoreAfterSafariReturn(state);
    });

    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) restoreAfterSafariReturn(state);
    });
  }

  function start() {
    document.querySelectorAll("[data-ua-catalog]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();